import { config } from "../config.js";
import type { MakeAuthenticateUserPayload } from "../types/MakeAuthenticateUserPayload.js";

export const makeAuthenticateUserPayload: MakeAuthenticateUserPayload = ({
  password,
  username,
}) => {
  return {
    password,
    platform: "web",
    twiageClient: config.appName,
    username,
  };
};
